import { render, staticRenderFns } from "./ecommerceFaq.vue?vue&type=template&id=1db32768"
import script from "./ecommerceFaq.vue?vue&type=script&lang=js"
export * from "./ecommerceFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports